import {
  useState,
  useMemo,
} from "react";

import { useGameContext } from "GameContext";
import { useWebSocket } from "WebSocketContext";

import { HIGHLIGHTS } from "utils/ToolTipConst";

const MAX_MONEY_TRANSFER = 5000

export default function Bank({
  onClose,
}: {
  onClose?: () => void,
}) {
  const { socket } = useWebSocket();
  const {
    roleGroups,
    players,
    playerInfo,
    hostId,
    proposedMoneyTransfers,

    selfRoleMoney,
    minDebt,
  } = useGameContext() as any;

  const selfKey = `${playerInfo?.estate}-${playerInfo?.role}`
  console.log("BANK SELF KEY : " + selfKey);
  const roleGroup = roleGroups[selfKey]

  const [sendMoneyAmount, setSendMoneyAmount] = useState(0);
  const [selectedSendMoneyRole, setSelectedSendMoneyRole] = useState("");
  const [tooMuchWarning, setTooMuchWarning] = useState(false);

  const moneyTransfers = useMemo(() => {
    return proposedMoneyTransfers.filter((transfer: any) => {
      return (selfKey === transfer?.fromGroupName || selfKey === transfer?.toGroupName)
    })
  }, [selfKey, proposedMoneyTransfers])

  const sendMoneyMemo = useMemo(() => {
    return sendMoneyAmount;
  }, [selfKey, sendMoneyAmount]);

  function sendMoney() {
    if ((selfRoleMoney ?? 0) < minDebt) {
      alert(`Your projected revenue reached the debt limit of ${minDebt}`);
      return
    }

    const fromWho = `${playerInfo?.estate}-${playerInfo?.role}`
    const toWho = selectedSendMoneyRole
    console.log("monies:" + JSON.stringify(moneyTransfers));

    let totalTransfered = 0;
    for (let i = 0; i < moneyTransfers.length; i++){
      let t = moneyTransfers[i];
      if(t.fromGroupName !== fromWho){
        continue;
      }
      else{
        totalTransfered += t.amountTransfer;
      }
    }
    if(totalTransfered + sendMoneyMemo>= MAX_MONEY_TRANSFER){
      setTooMuchWarning(true);
      return;
    } 
    else{
      console.log("EGADS!!! : " + totalTransfered + "money memo" + sendMoneyMemo);
      setTooMuchWarning(false);

      console.log("SEND MONEY TO WHO : " + toWho)

      if (!toWho) {
        return
      }

      if (sendMoneyAmount === 0) {
        return
      }

      const mes = JSON.stringify({
        kind: "MoneyTransferEvent",
        toIds: [hostId],
        authorId: playerInfo.id,
        amountTransfer: sendMoneyAmount,
        fromGroupName: fromWho,
        toGroupName: toWho,
      })

      socket?.send( mes );

      setSendMoneyAmount(0);
      setSelectedSendMoneyRole("");
    }
  }

  return (
    <div>
      <div className="flex flex-col">
        <button className="absolute top-2 right-2" onClick={onClose}>x</button>
        <p>Bank</p>
        <br/>
        <p>{`Initial Capital: ${Math.round(roleGroup?.money)}`}</p>
        <br/>
        <br/>

        <label>You can send money to another role.</label>
        <p>Choose the recipient:</p>
        <div
          onMouseDown={(e) => e.stopPropagation()}  // prevents WindowComponent from grabbing the event
        >
          <select
            className="border border-black rounded w-full mb-2"
            value={selectedSendMoneyRole}
            onChange={(e) => setSelectedSendMoneyRole(e.target.value)}
          >
            <option value="">&nbsp;Select a role</option>
            { players.filter((p: any) => p?.role != playerInfo?.role || p?.estate != playerInfo?.estate).map((p: any) => (
              <option key={`${p?.estate}-${p?.role}`} value={`${p?.estate}-${p?.role}`}>
                &nbsp;{p.role} {p.estate}
              </option>
            ))}
          </select>
        </div>
        <p>Choose the amount:</p>
        <div onMouseDown={e => e.stopPropagation()}>
          <input
            type="number"
            value={sendMoneyAmount}
            onChange={e => setSendMoneyAmount(Number(e.target.value))}
            placeholder=""
            className="no-spin border border-black rounded w-full mb-2 p-1"
            min={0}
          />
        </div>
        {tooMuchWarning && 
        
          <div>
            <br/>
            <p className={HIGHLIGHTS.negative}>You cannot send more than ${MAX_MONEY_TRANSFER} a year!</p>
            <br/>
          </div>}
        <button onClick={sendMoney} className="bg-[#BCB7A8] border-black border rounded-full w-full py-1">Transfer Money</button>

        { moneyTransfers.length > 0 && (
          <div className="flex flex-col border border-black rounded mt-4 p-2">
            <label className="text-center pb-2"> Money Transfers </label>
            
            <div className="flex flex-col gap-2">
              { moneyTransfers.map((transfer: any, i: number) => {
                const [fEstate, fRole] = transfer.fromGroupName.split("-");
                const [tEstate, tRole] = transfer.toGroupName.split("-");

                return <p key={i}>{`The ${fEstate} ${fRole} group sent ${transfer.amountTransfer} to the ${tEstate} ${tRole} group`}</p>
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
